import { Select, Stack, TextInput } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";

export type ParticularsFormType = {
  salutation?: string;
  first_name?: string;
  last_name?: string;
};

export type ParticularsFormErrorType = {
  salutation?: string[];
  first_name?: string[];
  last_name?: string[];
};

export const salutationData = [
  { value: "Frau", label: "Frau" },
  { value: "Herr", label: "Herr" },
  { value: "Divers", label: "Divers" },
];

type ParticularsFormProps<T extends ParticularsFormType | unknown> = {
  form: UseFormReturnType<T>;
  errors?: ParticularsFormErrorType;
  path?: string;
};

export function ParticularsForm<T extends ParticularsFormType | unknown>({ form, errors, path }: ParticularsFormProps<T>) {
  const getFieldPath = (value: string) => (path ? `${path}.${value}` : value);

  return (
    <Stack>
      <Select
        label="Anrede"
        withAsterisk
        data={salutationData}
        key={form.key(getFieldPath("salutation"))}
        {...form.getInputProps(getFieldPath("salutation"))}
        error={errors?.salutation}
      />
      <TextInput
        label="Vorname"
        withAsterisk
        key={form.key(getFieldPath("first_name"))}
        {...form.getInputProps(getFieldPath("first_name"))}
        error={errors?.first_name}
      />
      <TextInput
        label="Nachname"
        withAsterisk
        key={form.key(getFieldPath("last_name"))}
        {...form.getInputProps(getFieldPath("last_name"))}
        error={errors?.last_name}
      />
    </Stack>
  );
}
